export const NAME = 'name' as const;

export type SortField = typeof NAME;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default [NAME];
